import { Injectable } from '@angular/core';
import type { JsxgraphStatic } from './jsxgraph.model';

@Injectable({
  providedIn: 'root',
})
export class JsxgraphService {
  private jsxgraphInstance: JsxgraphStatic | null = null;

  get instance() {
    return this.jsxgraphInstance;
  }

  async loadJsxgraph(): Promise<JsxgraphStatic> {
    if (this.jsxgraphInstance) {
      return this.jsxgraphInstance;
    }

    this.jsxgraphInstance = (await import('jsxgraph')) as JsxgraphStatic;
    return this.jsxgraphInstance;
  }
}
